import React, { useState, ReactNode, useCallback, useMemo } from 'react'
import { ContactUpdateHistoryData, ContactUpdateHistoryContextValue, ContactUpdateHistoryContext } from './ContactUpdateHistoryTypes'

interface ContactUpdateHistoryProviderProps {
  children: ReactNode
}

export const ContactUpdateHistoryProvider: React.FC<ContactUpdateHistoryProviderProps> = ({ children }) => {
  const [historyData, setHistoryDataState] = useState<ContactUpdateHistoryData | null>(null)

  const setHistoryData = useCallback((data: ContactUpdateHistoryData) => {
    setHistoryDataState(data)
  }, [])

  const clearHistoryMode = useCallback(() => {
    setHistoryDataState(null)
  }, [])

  const contextValue: ContactUpdateHistoryContextValue = useMemo(
    () => ({
      isHistoryMode: historyData !== null,
      historyData,
      setHistoryData,
      clearHistoryMode,
    }),
    [historyData, setHistoryData, clearHistoryMode],
  )

  return <ContactUpdateHistoryContext.Provider value={contextValue}>{children}</ContactUpdateHistoryContext.Provider>
}
